export default "__VITE_ASSET__Cc$q8ayV__"